import { render, staticRenderFns } from "./cost-info.vue?vue&type=template&id=391b2edc"
import script from "./cost-info.vue?vue&type=script&lang=js"
export * from "./cost-info.vue?vue&type=script&lang=js"
import style0 from "./cost-info.vue?vue&type=style&index=0&id=391b2edc&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('391b2edc')) {
      api.createRecord('391b2edc', component.options)
    } else {
      api.reload('391b2edc', component.options)
    }
    module.hot.accept("./cost-info.vue?vue&type=template&id=391b2edc", function () {
      api.rerender('391b2edc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/cost-info.vue"
export default component.exports